import { render, staticRenderFns } from "./OfflineClipboard.vue?vue&type=template&id=0642ed73&"
import script from "./OfflineClipboard.vue?vue&type=script&lang=js&"
export * from "./OfflineClipboard.vue?vue&type=script&lang=js&"
import style0 from "./OfflineClipboard.vue?vue&type=style&index=0&id=0642ed73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports